import { render } from "./Home.vue?vue&type=template&id=3fd85d4b&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=3fd85d4b&lang=scss&scoped=true"

import exportComponent from "/Users/wlp9071/workspace/szbProject/lnyx/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd85d4b"]])

export default __exports__